export default "__VITE_ASSET__C04TDKq3__"